import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import {
  setLoadingProducts,
  setLoadingProduct,
  setLoadingProductCreate,
  setLoadingProductUpdate,
  setLoadingProductDelete,
  setErrorLoadingProducts,
  setErrorLoadingProduct,
  setErrorCreatingProduct,
  setErrorUpdatingProduct,
  setErrorDeletingProduct,
  setProducts,
  setProduct,
  createProductSuccess,
  updateProductSuccess,
  deleteProductSuccess,
  setServerResponseStatus,
} from "../slices/product";
import { getErrorMessage } from "../../utils/errorUtils";

export const getProducts = () => async (dispatch) => {
  dispatch(setLoadingProducts());

  try {
    const { data } = await axiosInstance.get("/products", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setProducts(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingProducts(getErrorMessage(error)));
  }
};

export const getProductById = (id) => async (dispatch) => {
  dispatch(setLoadingProduct());

  try {
    const { data } = await axiosInstance.get(`/products/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setProduct(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingProduct(getErrorMessage(error)));
  }
};

export const createProduct = (values) => async (dispatch) => {
  dispatch(setLoadingProductCreate());

  try {
    const { data } = await axiosInstance.post("/products", values, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Product created successfully!");
      dispatch(createProductSuccess(data.data));
      dispatch(
        setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorCreatingProduct(message));
  }
};

export const updateProduct =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingProductUpdate());

    try {
      const { data } = await axiosInstance.put(`/products/${id}`, values, {
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Product updated successfully!");
        dispatch(updateProductSuccess(data.data));
        dispatch(
          setServerResponseStatus({
            operation: "update",
            status: data.statusCode,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(setErrorUpdatingProduct(message));
    }
  };

export const deleteProduct = (id) => async (dispatch) => {
  dispatch(setLoadingProductDelete());

  try {
    const { data } = await axiosInstance.delete(`/products/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Product deleted successfully!");
      dispatch(deleteProductSuccess(id));
      dispatch(
        setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorDeletingProduct(message));
  }
};

export const resetProductServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
